// Filtros para búsqueda de tiendas
export interface Filters {
  searchTerm?: string;
  advanced_filters?: {
    filters: { column: string; operator: string; value: string }[];
    logic: 'AND' | 'OR';
  };
  team_id?: number; // Filtrar por equipo
  sortBy?: string; // Campo por el que ordenar
  sortDirection?: 'asc' | 'desc'; // Dirección del ordenamiento
  page?: number;
  limit?: number;
}

export interface ShopsModel {
  id: number;
  name: string; // "Aura Wear", "prueba"
  channel_id: number; // 1=Shopify, 3=WooCommerce, 4=Manual, 6=Amazon FBM
  status: number; // 0=Inactiva, >0=Activa
  connect_data: ConnectData;
  team_id: number;
  // Información del cliente (team). Presente solo si la API la incluye
  team?: ShopTeam;
  default_payment_method_id: number | null;
  fulfillment: any | null;
  approval_type: number; // 0, 2
  created_at: string;
  updated_at: string;
  linked_payment_methods: PaymentMethod[];
  last_synchronization: string | null; // Nueva: fecha de última sincronización
  image: string; // URL del icono del canal
  import_filters: any; // Soporta tanto el formato antiguo {include, exclude} como el nuevo array
}

export interface ConnectData {
  url: string; // URL de la tienda
  subdomain?: string; // Para Shopify
  access_token?: string; // Para Shopify
  client_key?: string; // Para WooCommerce
  client_secret?: string; // Para WooCommerce
  scope?: string; // Permisos Shopify
  team_id: number;
}

export interface PaymentMethod {
  id: number;
  payment_method_id: number;
  shop_id: number;
  team_id: number;
  title: string; // "shopify_payments", "PayPal", etc.
}

// Modelo para el cliente (team) asociado a la tienda
export interface ShopTeam {
  id: number;
  name: string;
}

// Constantes para estados y canales
export const SHOP_STATUS = {
  0: 'Inactiva',
  1: 'Activa',
} as const;

export const CHANNELS = {
  1: { name: 'Shopify', icon: 'shopify_icon.png' },
  3: { name: 'WooCommerce', icon: 'woocommerce.png' },
  4: { name: 'Tienda Manual', icon: '' },
  6: { name: 'Amazon FBM', icon: '' },
} as const;

/**
 * Canales que soportan importación de pedidos e historial (búsqueda).
 * 1=Shopify, 3=WooCommerce
 * Excluye 4 (Manual) y 6 (Amazon FBM)
 */
export const CHANNELS_WITH_IMPORT: readonly number[] = [1, 3];

/**
 * Canales con importación por archivo (TSV/TXT).
 * 6=Amazon FBM
 */
export const CHANNELS_WITH_FILE_IMPORT: readonly number[] = [6];

/**
 * Canales con configuración mínima: solo se puede editar el nombre.
 * 4=Manual, 6=Amazon FBM
 */
export const CHANNELS_MINIMAL_SETTINGS: readonly number[] = [4, 6];

export const SYNC_STATUS = {
  ready: 'Listo',
  syncing: 'Sincronizando',
  error: 'Error',
} as const;
